"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferPositionsDTO = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GroupOfferPositionDTO_1 = require("./GroupOfferPositionDTO");
const ScalarOfferPositionDTO_1 = require("./ScalarOfferPositionDTO");
const AbstractOfferPositionDTO_1 = require("./AbstractOfferPositionDTO");
class OfferPositionsDTO {
}
exports.OfferPositionsDTO = OfferPositionsDTO;
__decorate([
    (0, class_transformer_1.Type)(() => AbstractOfferPositionDTO_1.AbstractOfferPositionDTO, {
        discriminator: {
            property: 'positionType',
            subTypes: [
                {
                    name: 'scalar',
                    value: ScalarOfferPositionDTO_1.ScalarOfferPositionDTO
                },
                {
                    name: 'group',
                    value: GroupOfferPositionDTO_1.GroupOfferPositionDTO
                }
            ]
        },
        keepDiscriminatorProperty: true
    }),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], OfferPositionsDTO.prototype, "positions", void 0);
